export default __webpack_public_path__ + "static/media/passion-icon.1f6cdb56.png";